<template>
    <main-content>
        <kt-panel>
            <kt-panel-body>
                <ul class="nav nav-pills">
                    <li class="nav-item">
                        <router-link :class="['nav-link', $route.name == 'dedicated_stakeholders_list' ? 'active' : '']" :to="`/dedicated/stakeholders/${$route.params.hashid}`">{{ $t('stakeholders.label.shop_stakeholders_list') }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :class="['nav-link', $route.name == 'dedicated_allotment' ? 'active' : '']" :to="`/dedicated/${$route.params.hashid}/allotment`">{{ $t('allotment.allotment_details') }}</router-link>
                    </li>
                </ul>
                <slot></slot>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content.vue';

export default {
    components: {
        mainContent,
    },
}
</script>
